// Utility for localStorage access for language settings

import { LOCAL_STORAGE_KEY, Language } from './constants'
import { parseLanguage } from './utils'

export function getLanguageFromStorage(): Language | null {
  if (typeof window === 'undefined') return null
  const lang = localStorage.getItem(LOCAL_STORAGE_KEY)
  return lang ? parseLanguage(lang) : null
}

export function setLanguageToStorage(lang: Language): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(LOCAL_STORAGE_KEY, lang)
}

export function clearLanguageFromStorage(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(LOCAL_STORAGE_KEY)
}
